// Mirrors ProTalent.Domain.Enums.ScoringStatus / ScoringFailureReason.
// Backend serialises these as PascalCase strings.
export type ScoringStatus = "Pending" | "Scored" | "Failed"

export type ScoringFailureReason =
  | "None"
  | "InsufficientWalletBalance"
  | "AiServiceError"
  | "CvParseError"
  | "Unknown"

export function getScoringFailureLabel(reason: ScoringFailureReason): string {
  switch (reason) {
    case "InsufficientWalletBalance":
      return "Insufficient credits"
    case "AiServiceError":
      return "AI service error"
    case "CvParseError":
      return "CV parse error"
    case "Unknown":
      return "Unknown error"
    case "None":
    default:
      return ""
  }
}
